import * as React from 'react';
import { Divider } from '@repo/ui-web';
import { StateToggle } from '../../components/StateToggle';

export function DividerShowcase() {
  const variants = ['horizontal', 'vertical'] as const;
  type DividerVariant = (typeof variants)[number];

  const [variant, setVariant] = React.useState<DividerVariant>('horizontal');

  return (
    <div className="space-y-4">
      <StateToggle
        options={variants}
        value={variant}
        onChange={setVariant}
        label="Variant"
        formatLabel={(value) => value.charAt(0).toUpperCase() + value.slice(1)}
      />
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">
          {variant === 'horizontal' ? 'Horizontal' : 'Vertical'}
        </p>
        {variant === 'horizontal' ? (
          <div className="space-y-2">
            <p className="text-sm text-muted-foreground">Section above</p>
            <Divider />
            <p className="text-sm text-muted-foreground">Section below</p>
          </div>
        ) : (
          <div className="flex items-center gap-4">
            <span className="text-sm text-muted-foreground">Left</span>
            <Divider orientation="vertical" className="h-8" />
            <span className="text-sm text-muted-foreground">Right</span>
          </div>
        )}
      </div>
    </div>
  );
}
